<template>
    <div class="wrapper">
        <div class="columns">
            <div class="column has-text-centered">
                <app-loader :loading="getLoaderStatus" :color="options.color" :size="options.size"></app-loader>
                <h1 class="title" v-if="!getLoaderStatus">Messages from: {{ user.name }}</h1>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus">
            <div class="column is-full">
                <div style="padding-top: 20px; width: 100%;">
                    <table class="table is-responsive is-fullwidth is-hoverable">
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Subject</th>
                            <th>Body</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="mail in mails" class="link" @click="goToThread(mail)">
                            <td class="date">{{ mail.date.date.replace('.000000', '') }}</td>
                            <td class="subject">{{ mail.subject }}</td>
                            <td class="body">{{ mail.body }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiGmail from './../../../../api/apiGmail'
    import apiUsers from './../../../../api/apiUsers'
    import appLoader from 'vue-spinner/src/ClipLoader'
    export default {
        components: {
            appLoader
        },
        data(){
            return {
                options: this.$store.getters.getOptions,
                user: '',
                mails: [],
            }
        },
        methods: {
            goToThread(mail) {
                this.$router.push({
                    name: 'UserMessagesThread',
                    params: {
                        id: mail.info.id
                    },
                })
            }
        },
        computed: {
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
        },
        created(){
            this.$store.dispatch('setMessagesUserId', this.$route.params.id)
            this.$store.dispatch('setStatusLoading')
            apiGmail
                .getAllMailFromUserRequest(this.$route.params.id)
                .then((response) => {
                    this.mails = response.data
                    this.$store.dispatch('setStatusLoaded')
                })
                .catch(error => console.log(error))
            apiUsers
                .userRequest(this.$route.params.id)
                .then((response) => {
                    this.user = response.data
                })
                .catch(error => console.log(error))
        }
    }
</script>

<style scoped>
    .body {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display:block;
        max-width:900px;
        min-width:1px;
    }
    .date {
       width: 200px;
    }
    .subject {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width:100px;
        min-width:1px;
    }
    .link:hover {
        cursor: pointer;
    }
    .has-text-centered {
        margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/Messages/UserMessages.vue